import { render, staticRenderFns } from "./parallax-element.vue?vue&type=template&id=c922938e&"
import script from "./parallax-element.vue?vue&type=script&lang=js&"
export * from "./parallax-element.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports